// Extracted from `pages/CustomerDetailPage.js` (P2 refactor step 3).
// Dos modales de proyecto: creación (`ProjectModal`) y edición
// (`EditProjectModal`). Move 1:1 del JSX — sin cambios de estilo ni lógica.
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { FolderKanban, Plus, Save } from "lucide-react";

export const ProjectModal = ({
  open,
  onOpenChange,
  newProject,
  setNewProject,
  getServicesNotInProject,
  handleCreateProject,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0A0A35] border-[#1E1E5F] text-white max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-white font-heading flex items-center gap-2">
            <FolderKanban className="h-5 w-5 text-purple-400" />
            Nuevo Proyecto
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div>
            <Label className="text-slate-300">Nombre del Proyecto *</Label>
            <Input
              value={newProject.name}
              onChange={(e) => setNewProject({ ...newProject, name: e.target.value })}
              placeholder="Ej: Oficinas Centrales"
              className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
            />
          </div>
          <div>
            <Label className="text-slate-300">Descripción</Label>
            <Textarea
              value={newProject.description}
              onChange={(e) => setNewProject({ ...newProject, description: e.target.value })}
              placeholder="Descripción del proyecto (opcional)"
              className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white h-20"
            />
          </div>
          <div>
            <Label className="text-slate-300">Servicios a incluir</Label>
            <div className="mt-2 space-y-2 max-h-48 overflow-y-auto">
              {getServicesNotInProject().length === 0 ? (
                <p className="text-slate-400 text-sm">
                  No hay servicios activos disponibles para asignar
                </p>
              ) : (
                getServicesNotInProject().map(service => (
                  <label
                    key={service.id}
                    className="flex items-center gap-3 p-2 rounded bg-[#1B1B4B]/50 cursor-pointer hover:bg-[#1B1B4B]"
                  >
                    <input
                      type="checkbox"
                      checked={newProject.service_ids.includes(service.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setNewProject({
                            ...newProject,
                            service_ids: [...newProject.service_ids, service.id]
                          });
                        } else {
                          setNewProject({
                            ...newProject,
                            service_ids: newProject.service_ids.filter(id => id !== service.id)
                          });
                        }
                      }}
                      className="rounded border-[#1E1E5F]"
                    />
                    <div className="flex-1">
                      <p className="text-white text-sm">{service.nombre_servicio}</p>
                      <p className="text-slate-400 text-xs">{service.nombre_sede}</p>
                    </div>
                  </label>
                ))
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-6">
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false);
              setNewProject({ name: "", description: "", service_ids: [] });
            }}
            className="border-[#1E1E5F] text-slate-300"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleCreateProject}
            className="bg-[#42E695] text-[#04042C]"
          >
            <Plus className="h-4 w-4 mr-2" />
            Crear Proyecto
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const EditProjectModal = ({
  open,
  onOpenChange,
  selectedProject,
  setSelectedProject,
  services,
  handleUpdateProject,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0A0A35] border-[#1E1E5F] text-white max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-white font-heading flex items-center gap-2">
            <FolderKanban className="h-5 w-5 text-purple-400" />
            Editar Proyecto
          </DialogTitle>
        </DialogHeader>
        {selectedProject && (
          <div className="space-y-4 mt-4">
            <div>
              <Label className="text-slate-300">Nombre del Proyecto *</Label>
              <Input
                value={selectedProject.name}
                onChange={(e) => setSelectedProject({ ...selectedProject, name: e.target.value })}
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
              />
            </div>
            <div>
              <Label className="text-slate-300">Descripción</Label>
              <Textarea
                value={selectedProject.description || ""}
                onChange={(e) => setSelectedProject({ ...selectedProject, description: e.target.value })}
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white h-20"
              />
            </div>
            <div>
              <Label className="text-slate-300">Servicios incluidos</Label>
              <div className="mt-2 space-y-2 max-h-48 overflow-y-auto">
                {services.filter(s => s.estado === "ACTIVO").map(service => (
                  <label
                    key={service.id}
                    className="flex items-center gap-3 p-2 rounded bg-[#1B1B4B]/50 cursor-pointer hover:bg-[#1B1B4B]"
                  >
                    <input
                      type="checkbox"
                      checked={(selectedProject.service_ids || []).includes(service.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedProject({
                            ...selectedProject,
                            service_ids: [...(selectedProject.service_ids || []), service.id]
                          });
                        } else {
                          setSelectedProject({
                            ...selectedProject,
                            service_ids: (selectedProject.service_ids || []).filter(id => id !== service.id)
                          });
                        }
                      }}
                      className="rounded border-[#1E1E5F]"
                    />
                    <div className="flex-1">
                      <p className="text-white text-sm">{service.nombre_servicio}</p>
                      <p className="text-slate-400 text-xs">{service.nombre_sede}</p>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        )}
        <div className="flex justify-end gap-3 mt-6">
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false);
              setSelectedProject(null);
            }}
            className="border-[#1E1E5F] text-slate-300"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleUpdateProject}
            className="bg-[#42E695] text-[#04042C]"
          >
            <Save className="h-4 w-4 mr-2" />
            Guardar Cambios
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
